if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
  const mediaId = event.detail.currentElement.dataset.mediaId;
  const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
  this.setActiveThumbnail(thumbnail);

  this.selectVariantFromMedia(mediaId);
}

selectVariantFromMedia(mediaId) {
  if (this.dataset.woolSync !== 'true') return;

  const sectionId = this.id.replace('MediaGallery-', '');
  const picker =
    document.querySelector(`variant-selects[data-section="${sectionId}"]`) ||
    document.querySelector(`variant-radios[data-section="${sectionId}"]`);

  if (!picker || picker._syncingFromMedia) return;

  const dataElement = picker.querySelector('script[type="application/json"]');
  if (!dataElement) return;

  let variants;
  try {
    variants = JSON.parse(dataElement.textContent);
  } catch (error) {
    return;
  }

  const mediaIdOnly = String(mediaId).split('-').pop();
  const matches = variants.filter((variant) =>
    variant.featured_media &&
    String(variant.featured_media.id) === mediaIdOnly
  );

  if (matches.length !== 1) return;

  const matchingVariant = matches[0];
  const isDropdown = picker.tagName.toLowerCase() === 'variant-selects';

  const controls = isDropdown
    ? Array.from(picker.querySelectorAll('select'))
    : Array.from(picker.querySelectorAll('fieldset'));

  const currentOptions = controls.map((control) =>
    isDropdown
      ? control.value
      : control.querySelector('input[type="radio"]:checked')?.value
  );

  if (
    matchingVariant.options.length !== controls.length ||
    matchingVariant.options.every(
      (value, index) => value === currentOptions[index]
    )
  ) return;

  const targets = controls.map((control, index) =>
    Array.from(
      control.querySelectorAll(
        isDropdown ? 'option' : 'input[type="radio"]'
      )
    ).find((input) => input.value === matchingVariant.options[index])
  );

  if (targets.some((target) => !target)) return;

  picker._syncingFromMedia = true;

  try {
    controls.forEach((control, index) => {
      if (isDropdown) {
        control.value = matchingVariant.options[index];
      } else {
        targets[index].checked = true;
      }
    });

    const changedControl = isDropdown
      ? controls[controls.length - 1]
      : targets[targets.length - 1];

    changedControl.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  } finally {
    picker._syncingFromMedia = false;
  }
}

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
